import { useMemo, useState } from "react";

import LogoSection from "../../components/logoSection/LogoSection";
import useDashboardQuery from "../../hooks/graphql-hooks/queries/useDashboardQuery";
import { DeliveryCount } from "../../models/deliveryCount";
import { TagName } from "../../models/tag";
import "./Dashboard.scss";
import WelcomeSection from "./sections/welcomeSection/WelcomeSection";
import YourDeliveriesSection from "./sections/yourDeliveriesSection/YourDeliveriesSection";

const initialCounts: DeliveryCount[] = [
  { key: TagName.Today, value: 0 },
  { key: TagName.Tomorrow, value: 0 },
  { key: TagName.Future, value: 0 },
  { key: TagName.NotPlanned, value: 0 },
  { key: TagName.AllDeliveries, value: 0 },
];

interface DashboardScreenProps {}

const Dashboard = (props: DashboardScreenProps) => {
  const [counts, setCounts] = useState(initialCounts);

  const { loading } = useDashboardQuery({
    dataAction: (dashboard) => {
      const today = dashboard.yourDeliveries.today;
      const tomorrow = dashboard.yourDeliveries.tomorrow;
      const future = dashboard.yourDeliveries.future;
      const notPlanned = dashboard.yourDeliveries.notPlanned;

      setCounts([
        { key: TagName.Today, value: today },
        { key: TagName.Tomorrow, value: tomorrow },
        { key: TagName.Future, value: future },
        { key: TagName.NotPlanned, value: notPlanned },
        {
          key: TagName.AllDeliveries,
          value: today + tomorrow + future + notPlanned,
        },
      ]);
    },
  });

  const deliveryCount = useMemo<DeliveryCount[]>(() => counts, [counts]);

  return (
    <div className="home-screen-container">
      <div className="welcome-container">
        <div className="welcome-section welcome-container-divider">
          <WelcomeSection />
        </div>
        <div className="your-deliveries-section welcome-container-divider">
          <YourDeliveriesSection
            deliveryCount={deliveryCount}
            loading={loading}
          />
        </div>
      </div>
      <div className="home-screen-footer">
        <div className="home-screen-footer-corner-left" />
        <div className="bonussystem-section">
          <LogoSection variant="arvato" />
        </div>
        <div className="home-screen-footer-corner-right" />
      </div>
    </div>
  );
};

export default Dashboard;
